const LINK_HAP = 'https://www.hapvida.com.br/site/vendas/';
const LINK_GNDI =
	'https://privacyportal-br.onetrust.com/webform/ee7c4956-20cc-4532-a3f0-44beb001c961/68f40e29-f9d9-46d5-bac5-3795f6964960';

export {LINK_HAP, LINK_GNDI};
